import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const HomeDes3 = ({language}) => {
    return (
        <section className="home-des3">
            <Container>
                <Row className='align-items-center text-center'>
                    {
                        language === 'Chinese' ? (
                            <Col size={12} md={12}>
                                <h1><span className='theme-color'>環法自行車挑戰賽第三度登場日月潭</span></h1>
                                <p>全球十大最美自行車路線</p>
                            </Col>
                        ) : (
                                <Col size={12} md={12}>
                                    <h1><span className='theme-color'>L’Étape by Tour de France Returns to Sun Moon Lake for Its 3rd Edition</span></h1>
                                    <p>One of the World's 10 Most Beautiful Cycling Routes</p>
                                </Col>
                        )
                    }
                </Row>
            </Container>
        </section>
    )
}

export default HomeDes3